// A production status is not proof that a file or invoice reached a customer.
// This adapter only composes the explicitly recorded roster wait currently
// available from the lane. Other tracks expose their missing evidence internally.
export function laneDraft(order, sender) {
  const missing=[]
  if(!order?.orderId || !order?.name)missing.push('the current production order')
  if(!sender?.id || !String(sender?.name||'').trim() || /[\r\n]/.test(sender.name))missing.push('the signed-in representative name')
  const owes=order?.customerOwes||[]
  const roster=owes.find(o=>o.track==='roster')
  if(!roster)missing.push('a verified customer action due on this order; proof sharing and invoice delivery are not supplied by this feed')
  if(missing.length)return {available:false,body:'',missing}
  const contact=String(order?.contact?.name||'').trim()
  const rosterAttached=order.tracks?.find(t=>t.key==='roster')?.detail?.finalRosterAttached===true
  const ask=rosterAttached
    ? 'Would you add the outstanding ring sizes to this order in the Team Meeting Room?'
    : 'Would you add the final roster with confirmed name spellings and ring sizes to this order in the Team Meeting Room?'
  return {available:true,missing:[],body:[contact ? `${contact},` : '',
    `For ${order.name}, the roster and sizes identify the ring each recipient will wear.`,
    ask,`Thanks,\n${sender.name.trim()}\nSouthern Recognition`].filter(Boolean).join('\n\n')}
}
